import { useInfiniteQuery } from "@tanstack/react-query";
import api from "../services/axios";

export default function useNearbyEvents({ coordinates, date, city, baseCity, locationData, enabled = true, ...params }) {
   const url = "/api/events"
   
   // Validate coordinates are finite numbers
   const hasValidCoordinates =
      coordinates &&
      Number.isFinite(coordinates?.latitude) &&
      Number.isFinite(coordinates?.longitude);
   
   const coordinatesStr = hasValidCoordinates 
      ? [coordinates.latitude, coordinates.longitude].join(',') 
      : null;

   // Only enable query if coordinates are valid AND explicitly enabled
   const isQueryEnabled = !!(enabled && hasValidCoordinates);

   return useInfiniteQuery({
      queryKey: ['nearby-events', { coordinatesStr, date, city, baseCity }],
      async queryFn({ signal, pageParam = 0 }) {
         const { data } = await api.get(url, {
            params: {
               view: "nearby-events",
               __query: "nearby-events",
               upcoming: 1,
               city,
               userBaseCity: baseCity,
               date,
               coordinates: coordinatesStr,
               location: locationData ? JSON.stringify(locationData) : null,
               page: pageParam,
               ...params
            },
            signal
         })
         return data
      },
      getNextPageParam: (lastPage, pages) => {
         return lastPage.cursor ?? lastPage.nextCursor ?? undefined;
      },
      placeholderData: {
         pages: []
      },
      enabled: isQueryEnabled,
      staleTime: 5 * 60 * 1000, // 5 minutes
   })
}
